import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { DeleteButton, EditButton } from "@refinedev/mui";

import { ModalRef, TableCell } from "@shared/components";

export const useMagazineTemplatesListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  editMagazineTemplatesModalRef: RefObject<ModalRef>
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "id",
        headerName: translate("magazine/magazine_template_admin.fields.id"),
        width: 80,
      },
      {
        field: "file",
        headerName: translate("magazine/magazine_template_admin.fields.file"),
        minWidth: 300,
        flex: 1,
        headerAlign: "left",
      },
      {
        field: "reference_month",
        headerName: translate(
          "magazine/magazine_template_admin.fields.reference_month"
        ),
        minWidth: 150,
        headerAlign: "left",
        renderCell: ({ value }) => {
          return (
            <TableCell.Text
              value={translate(`options.months.${value}`)}
              textAlign="left"
            />
          );
        },
      },
      {
        field: "reference_year",
        headerName: translate(
          "magazine/magazine_template_admin.fields.reference_year"
        ),
        minWidth: 150,
        headerAlign: "center",
        renderCell: ({ value }) => (
          <TableCell.Text value={value} textAlign="center" />
        ),
      },
      {
        field: "created_at",
        headerName: translate(
          "magazine/magazine_template_admin.fields.created_at"
        ),
        minWidth: 120,
        headerAlign: "center",
        renderCell: ({ value }) => (
          <TableCell.Date value={value} align="center" />
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              onClick={() => editMagazineTemplatesModalRef.current?.open(row)}
            />

            <DeleteButton
              hideText
              recordItemId={row.id}
              resource="v2/magazine/magazine_template_admin"
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, editMagazineTemplatesModalRef]
  );
};
